<template>
  <div class="cartypes">
    <!-- 步骤条 -->
    <div class="steps">
      <!-- 品牌 -->
      <!-- <div class="steps-brand" v-show="brand"> -->
      <div class="steps-one" v-show="brand">
        <ul>
          <li>
            <img src="@/assets/images/carImg/status1/group 230.png" alt="" />
            <span>选择品牌</span>
          </li>
          <div class="steps-img">
            <img src="@/assets/images/carImg/arrows/group -1.png" alt="" />
          </div>
          <li>
            <img src="@/assets/images/carImg/status1/group 231.png" alt="" />
            <span>选择车系</span>
          </li>
          <div class="steps-img">
            <img src="@/assets/images/carImg/arrows/group -1.png" alt="" />
          </div>
          <li>
            <img src="@/assets/images/carImg/status1/group 232.png" alt="" />
            <span>选择车型</span>
          </li>
        </ul>
        <div class="steps-brand">
          <!-- 字母 -->
          <div class="steps-brandName">
            常用车型：<span
              @click="checkedBrand(item)"
              v-for="item in alphabet"
              :key="item.id"
              :class="carchecked1 === item ? 'checked' : ''"
              >{{ item }}
            </span>
          </div>
          <!-- 图片 -->
          <div class="steps-brandImg">
            <ul>
              <li
                v-for="item in alphabetImgs"
                :key="item.carBrandId"
                @click="checkImg(item)"
              >
                <img
                  :src="
                    item.carBrandLogo == null
                      ? 'https://vin.g-part.cn/images/brand/%E5%A4%A9%E9%99%85.jpg'
                      : item.carBrandLogo
                  "
                  alt=""
                />
                <span>{{ item.carBrandName }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- </div> -->

      <!-- 车系 -->
      <!-- <div class="steps-carseries" v-show="carseries"> -->
      <div class="steps-one" v-show="carseries">
        <ul>
          <li>
            <img src="@/assets/images/carImg/status1/group 230.png" alt="" />
            <span>选择品牌</span>
          </li>
          <div class="steps-img">
            <img src="@/assets/images/carImg/arrows/group 92.png" alt="" />
          </div>
          <li>
            <img src="@/assets/images/carImg/status2/group 231.png" alt="" />
            <span>选择车系</span>
          </li>
          <div class="steps-img">
            <img src="@/assets/images/carImg/arrows/group -1.png" alt="" />
          </div>
          <li>
            <img src="@/assets/images/carImg/status1/group 232.png" alt="" />
            <span>选择车型</span>
          </li>
        </ul>
        <div class="steps-carseries">
          <div class="steps-carseries-top">
            已选车型
            <span>
              {{ nameList.brandName }}
              <Icon type="md-close-circle" size="14" @click="delbrandName"
            /></span>
          </div>
          <!-- <div class="divs"> -->
          <div
            class="steps-carseries-bottom"
            v-for="item in carSeries"
            :key="item.id">
            <p>{{ item }}</p>
            <div class="divs">
              <span
                v-for="i in a[item]"
                :key="i.id"
                @click="checkCarBrand(i)"
                >{{ i.name }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 车型 -->
      <!-- <div class="steps-cartype" v-show="cartype"> -->
      <div class="last-box" v-show="cartype">
        <div class="steps-one">
          <ul>
            <li>
              <img src="@/assets/images/carImg/status1/group 230.png" alt="" />
              <span>选择品牌</span>
            </li>
            <div class="steps-img">
              <img src="@/assets/images/carImg/arrows/group 92.png" alt="" />
            </div>
            <li>
              <img src="@/assets/images/carImg/status2/group 231.png" alt="" />
              <span>选择车系</span>
            </li>
            <div class="steps-img">
              <img src="@/assets/images/carImg/arrows/group 92.png" alt="" />
            </div>
            <li>
              <img src="@/assets/images/carImg/status2/group 232.png" alt="" />
              <span>选择车型</span>
            </li>
          </ul>
          <div class="steps-cartype">
            <div class="steps-carseries-top">
              已选车型
              <span
                >{{ nameList.brandName }}
                <Icon type="md-close-circle" size="14" @click="delbrandName"
              /></span>
              <img src="@/assets/images/carImg/arrows-img.png" alt="" />
              <!-- <Icon type="md-arrow-round-forward" color="#DEDEDE" size="14" /> -->
              <span
                >{{ nameList.carName }}
                <Icon type="md-close-circle" size="14" @click="delcartypeName"
              /></span>
            </div>
            <div class="steps-cartype-bottom">
              <div class="steps-cartype-search">
                <Input
                  v-model="intValue"
                  placeholder="请输入想要的车型"
                  style="width: 301px"
                />
                <Button type="primary" @click="searchType" :loading="loading"
                  >搜索</Button
                >
              </div>
              <div class="steps-cartype-name" v-if="motorcycleType.length">
                <span
                  @click="cehcekType(item)"
                  v-for="item in motorcycleType"
                  :key="item.id"
                  :class="carchecked3 === item.id ? 'checked3' : ''"
                  >{{ item.carBrandName }} {{ item.carModelName }} {{ item.engineNo }} {{ item.displacement  }} {{ item.transmissionDescribe }} {{ item.salesVersion }} {{ item.fuelType }} {{ item.modelYear }}
                </span>
              </div>
              <div v-else class="zanwu">暂无数据</div>
            </div>
          </div>
        </div>
        <div class="steps-cartype-btn">
          <Button type="primary" class="last-box-btn" @click="btnok"
            >确定</Button
          >
        </div>
      </div>

      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import {
  getlistAllLabel,
  getListCarSeries,
  getCarModel
} from '@/api/partnavigation.js'
export default {
  components: {},
  data() {
    return {
      nameList: {
        carName: '', // 选中车系名字
        brandName: '', // 选中品牌名字
        // modelVO:{
          brand:'',
          series:'',
          model:'',
          model_year:'',
          cc:'',
          trans_code:''
        // }
      },
      carNameList: '',
      carchecked3: '',
      loading: false,
      carList: {},
      motorcycleType: [], // 车型数据
      intValue: '', // 车型输入框
      carSeries: [], // 车系数据
      carchecked1: '', // 选中字母开头
      brand: true, // 品牌显示
      carseries: false, // 车系显示
      cartype: false, // 车型显示
      alphabetList: {}, // 厂牌数据字母
      alphabet: [],
      alphabetImgs: [], // 选中字母图片数据
      a: ''
    }
  },
  created() {
    // this.getlistAllLabel()
  },
  methods: {
    // 获取品牌
    async getlistAllLabel() {
      this.nameList = {}
      this.carchecked3 = ''
      this.carchecked1 = 'A'
      const res = await getlistAllLabel()
      console.log(res)
      this.alphabet = res.data.firstChar
      this.alphabetList = res.data.relation
      this.alphabetImgs = this.alphabetList[this.carchecked1]
      this.brand = true
      this.carseries = false
      this.cartype = false
    },
    // 点击切换字母状态
    checkedBrand(item) {
      this.carchecked1 = item
      this.alphabetImgs = this.alphabetList[this.carchecked1]
    },
    // 选品牌
    async checkImg(item) {
      this.intValue = ''
      console.log(item)
      const res = await getListCarSeries({ carBrandId: item.carBrandId })
      console.log(res)
      if (res.status) {
        this.nameList.brandName = item.carBrandName
        this.carSeries = res.data.nameList
        this.a = res.data
        this.brand = false
        this.carseries = true
      }
    },
    // 删除品牌
    delbrandName() {
      this.delcartypeName()
      this.nameList.brandName = ''
      this.brand = true
      this.carseries = false
    },
    // 删除车系列
    delcartypeName() {
      this.nameList.carName = ''
      this.nameList.id = ''
      this.brand = false
      this.carseries = true
      this.cartype = false
      this.intValue = ''
    },
    // 选择车系
    async checkCarBrand(i) {
      console.log(i)
      this.carList = i
      const res = await getCarModel({ id: i.id })
      console.log(res, '111111')
      if (res.status) {
        this.nameList.carName = i.name

        this.motorcycleType = res.data.list
        this.brand = false
        this.carseries = false
        this.cartype = true
      }
    },
    // 搜索车型
    async searchType() {
      this.loading = true
      const res = await getCarModel({
        id: this.carList.id,
        name: this.intValue
      })
      console.log(res)
      if (res.status) {
        this.motorcycleType = res.data.list
        this.brand = false
        this.carseries = false
        this.cartype = true
      }
      this.loading = false
    },
    // 选中车型状态
    cehcekType(val) {
      console.log(val);
      console.log(this.nameList)
      this.nameList.carType = val.name
      this.nameList.id = val.id
      this.nameList.epc = val.epc
      this.nameList.brand = val.carBrandName
      this.nameList.series = val.carBrandSeriesName
      this.nameList.model = val.carModelName
      this.nameList.model_year = val.modelYear
      this.nameList.cc = val.displacement
      this.nameList.trans_code = val.transmissionNo
      this.nameList.engine_no = val.engineNo
      this.carchecked3 = val.id
      this.carNameList = JSON.parse(JSON.stringify(this.nameList))
      this.$emit('closeMOdal', this.carNameList)
      // console.log(this.carchecked3)
      // if (id) {
      // }
    },
    // 确定车型
    btnok() {
      console.log(this.carchecked3, '111111111111')
      if (this.carchecked3 == '') {
        this.$Message.warning('请选择车型')
      } else {
        // console.log(this.nameList)
        // console.log(this.nameList.carType)
        this.carNameList = JSON.parse(JSON.stringify(this.nameList))
        this.$emit('closeMOdal', this.carNameList)
        console.log(this.carchecked3)
      }
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang='less' scoped>
@import './index.less';
</style>